__turbopack_context__.v({
  "dropdownIcon": "_ZO8ya_dropdownIcon",
  "listItemText": "_ZO8ya_listItemText",
  "navigationItem": "_ZO8ya_navigationItem",
  "nestedList": "_ZO8ya_nestedList",
  "open": "_ZO8ya_open",
  "selected": "_ZO8ya_selected",
  "styleGuideList": "_ZO8ya_styleGuideList",
});
